// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"VM-z","smallCardRow":"WM-z","largeCardRow":"XM-z","productSearchRow":"YM-z","curatedRow":"ZM-z"};